import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type Location from 'garaje/models/location';
import type LocationSubscription from 'garaje/models/location-subscription';
import type Subscription from 'garaje/models/subscription';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type StateService from 'garaje/services/state';

export interface VisitorsInvitesGroupsIndexRouteModel {
  vrSubscription: Subscription | LocationSubscription | null;
  currentLocation: Location;
}

export default class VisitorsGroupInvitesIndexRoute extends Route {
  @service declare featureFlags: FeatureFlagsService;
  @service declare router: RouterService;
  @service declare state: StateService;

  get canAccessGroupInvites(): boolean {
    if (!this.featureFlags.isEnabled('visitors-generic-invite-link')) return false;
    return Boolean(this.state.vrSubscription?.canAccessGroupInviteRecords);
  }

  beforeModel(): void {
    if (!this.canAccessGroupInvites) {
      void this.router.replaceWith('visitors.invites.index');
    }
  }

  model(): VisitorsInvitesGroupsIndexRouteModel {
    const { vrSubscription, currentLocation } = this.state;

    return { vrSubscription, currentLocation };
  }
}
